import {MemoryClient} from 'utils';

export const ACCOUNT_DEACTIVATED_EVENT = 'account-deactivated';

// Called from anywhere a deactivation response is detected (the axios
// interceptor, which runs outside the React tree, and the authSlice thunks
// that bypass that interceptor). Clears the token immediately so no further
// request goes out authenticated, and fires a DOM event so the App-level
// overlay can block the whole UI. Redux auth state itself gets reset by the
// hard reload the overlay triggers on "Go to Sign In" — not dispatched from
// here, to avoid a utils/deactivation -> store -> authSlice -> utils/deactivation
// import cycle.
let alreadyTriggered = false;

export function triggerAccountDeactivated() {
  if (alreadyTriggered) return;
  alreadyTriggered = true;

  MemoryClient.clearAll();
  window.dispatchEvent(new Event(ACCOUNT_DEACTIVATED_EVENT));
}
